import api from './api';

export { API } from './api';
export default api;

export { ApiProblemError, collectionOf, moduleApi, resourceOf, toApiProblem } from './moduleApi';
export type { ApiCollection, ApiPagination, ApiProblemFieldError } from './moduleApi';
